<template>
  <el-row>
    <el-row style="margin: 10px 15%;" class="card">
      <el-form label-position="left">
        <el-form-item label="生成密码的数目:">
          <el-input v-model.number="passwdNumber" type="number" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="密码长度:">
          <el-input v-model.number="passwdLength" type="number" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="使用的字符列表">
          <el-input v-model="characterString" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-checkbox v-model="checked.numberChecked" @change="changeString">数字 {{ number }}</el-checkbox>
          <el-checkbox v-model="checked.lowercaseChecked" @change="changeString">小写字母 {{ lowercaseLetter }}</el-checkbox>
          <el-checkbox v-model="checked.uppercaseChecked" @change="changeString">大写字母 {{ uppercaseLetter }}</el-checkbox>
          <el-checkbox v-model="checked.characterChecked" @change="changeString">常用符号 {{ character }}</el-checkbox>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="primary" @click="generatePwd">生成</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <br/>
    <el-row style="margin: 10px 15%; text-align: center">
      <el-table border :data="formattedData" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="passwd" label="密码" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button  size="small" type="primary" @click="copyPass(scope.row.passwd)">copy</el-button>
            <el-button  size="small" type="primary" @click="generateQRCode(scope.row.passwd)">qr</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog
        title="二维码"
        :visible.sync="dialogVisible"
        width="30%">
      <div>
        <vue-qr
            :text="qrText"
            :size="200"
            :margin="10"
            colorLight="white"
            :logoScale="0.2"
            :dotScale="0.7">
        </vue-qr>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import clipboard from "clipboard";
import vueQr from 'vue-qr/src/packages/vue-qr.vue'


export default {
    name: "HomeView",
    components: { vueQr },
    data() {
      return {
        dialogVisible: false,

        passwdNumber: 10,
        passwdLength: 10,

        number: "0123456789",
        lowercaseLetter: "abcdefghijklmnopqrstuvwxyz",
        uppercaseLetter: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        character: "~!@#$%^&*()_+",

        characterString:'',
        passwdList:[],

        checked:{
          numberChecked: true,
          lowercaseChecked: true,
          uppercaseChecked: true,
          characterChecked: true,
        },
        qrText:''
      }
    },
    computed: {
      formattedData() {
        return this.passwdList.map(item => {
          return { passwd: item };
        });
      },
    },
    created() {
      const checked = JSON.parse(localStorage.getItem('checked'))
      const characterString = localStorage.getItem('characterString')
      if (characterString!=null){
        this.characterString = characterString
      }else {
        this.characterString = this.number + this.lowercaseLetter + this.uppercaseLetter + this.character
      }
      if (checked!=null){
        this.checked = checked
      }
      this.generatePwd()
    },
    methods: {
      changeString() {
        let characterString = ""
        if (this.checked.numberChecked){
          characterString += this.number
        }
        if (this.checked.lowercaseChecked){
          characterString += this.lowercaseLetter
        }
        if (this.checked.uppercaseChecked){
          characterString += this.uppercaseLetter
        }
        if (this.checked.characterChecked){
          characterString += this.character
        }
        this.characterString = characterString
        localStorage.setItem('checked', JSON.stringify(this.checked));
        localStorage.setItem('characterString', characterString);
      },
      generatePwd() {
        if (this.characterString === "") {
          this.$message({
            message: '候选项不能为空',
            type: 'error'
          });
          return;
        }
        let passwdList  = []
        for (let i = 0; i < this.passwdNumber; i++) {
          let passwd = '';
          for (let j = 0; j < this.passwdLength; j++) {
            var randomNum = Math.floor(Math.random() * this.characterString.length);
            passwd += this.characterString[randomNum]
          }
          passwdList.push(passwd)
        }
        this.passwdList = passwdList
        this.$message({
          message: '密码生成成功',
          type: 'success'
        });
      },
      async copyPass(pass) {
        clipboard.copy(pass)
        this.$message({
          message: '密码拷贝成功',
          type: 'success'
        });
      },
      generateQRCode(pass) {
        console.log(pass)
        this.dialogVisible = true;
        this.qrText = pass
      },
    }
  }
</script>

<style scoped>

</style>